import React, { useEffect } from 'react';
import { useState } from 'react';
import { store } from 'components/Store.js';
import { useContext } from 'react';
import SearchBarWithEmailPerformance from './SearchBarWithEmailPerformance.js';
import useEmailComponentFunctions from 'components/Dashboard/Influence/CrmEmails/useEmailComponentFunctions.js';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Axios from 'axios';
import { normalizedDateUK } from 'components/Dashboard/utilities/normalizedDateUK.js';
import useAddMetaTags from 'components/Dashboard/utilities/addMetaTags.js';

const EngagementStatisticsDropdown = () => {
  const globalState = useContext(store);
  const { state, dispatch } = globalState;
  const { listDomainsVerified } = state;

  const [sentEmails, setSentEmails] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const params = useParams();
  const { crmEmailId } = params;

  const { loadSentEmails } = useEmailComponentFunctions();
  const { addMetaTags } = useAddMetaTags();

  const showSearchBarCondition =
    sentEmails.length > 0 || listDomainsVerified?.verifiedDomains?.some((domain) => domain?.sentEmailCount > 0);

  // INITIAL LOAD
  useEffect(() => {
    const CancelToken = Axios.CancelToken;
    const source = CancelToken.source();
    loadSentEmails({ setSentEmails, source });
    return () => {
      source.cancel('Email performance api call canceled by the user');
    };
  }, []);

  useEffect(() => {
    return dispatch({
      type: 'MODIFY_SECTION',
      parameter: 'emailPerformanceOnLoad',
      value: true,
    });
  }, []);

  useEffect(() => {
    if (!crmEmailId && !!sentEmails.length) {
      navigate(`/influence/email-performance/${sentEmails[0].crmEmailId}`);
    }
  }, [sentEmails, location.pathname]);

  useEffect(() => {
    if (crmEmailId) {
      let title = `Email performance - Influence - PolicyMogul`;
      addMetaTags({ title, hash: null });
    }
  }, [crmEmailId]);

  const selectedEmail = sentEmails.find((item) => item.crmEmailId === parseFloat(crmEmailId));
  let buttonText = `Sent on ${normalizedDateUK(selectedEmail?.finishedSendingAt).format('D MMM YYYY')} at ${normalizedDateUK(selectedEmail?.finishedSendingAt).format('H:mm')}`;

  return showSearchBarCondition ? (
    <div className='flex-centered flex-grow-1 justify-content-between'>
      <SearchBarWithEmailPerformance sentEmails={sentEmails} isOpen={isOpen} setIsOpen={setIsOpen} />
      <div className='d-md-block d-none ml-3'>
        <span
          className={`crm-table-item-state nowrap-item sent-state-badge border email-state-sent w-auto px-4 ${!selectedEmail?.finishedSendingAt ? 'text-transparent' : ''}`}
        >
          {buttonText}
        </span>
      </div>
    </div>
  ) : (
    <div className='flex-grow-1'></div>
  );
};

export default EngagementStatisticsDropdown;
